<template>
  <div class="stockup" ref="maChart" id="main">
  </div>
</template>
<script>

export default ({
  data () {
    return {
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {
            fontSize: 18,//字体大小
            color: '#fff'//修改标签字体颜色
          },
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            // itemStyle: {
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2, 
            // },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold',
                color: '#fff',
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1048, name: '高值' },
              { value: 735, name: '低值' },
              { value: 580, name: '试剂' },
              { value: 484, name: '其他' }
            ]
          }
        ],
        // 修改图例颜色
        // color: ['blue', '#121122', 'red',''],
      }
    };
  },
  methods: {
    // 获取列表
    getData () {


    },
    // 编辑
    // handleUpdate(row) {
    //   this.$router.push("/card-edit?formMode=2&id=" + row.id);
    // },
    init () {
      let myChart = this.$echarts.init(this.$refs['maChart'])
      myChart.setOption(this.option);
    }
  },//自定义指令

  mounted () {
    // this.queryNoCard();
    // var chart = echarts.init(dom, 'dark');
    this.init()
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
})
</script>
<style scoped>
.stockup {
  width: 100%;
  height: 100%;
  resize: both;
  overflow: auto;
  position: absolute;
}
</style>
